// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.api-docs {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 0;
}

.api-docs-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 1.25rem 2rem;
  color: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.api-base-url {
  margin-top: 15px;
  font-size: 0.95rem;
}

.api-base-url code {
  background: rgba(255, 255, 255, 0.2);
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 1rem;
}

.api-docs-container {
  width: 100%;
  margin: 2rem auto;
  padding: 0 2rem;
  max-width: 1400px;
  display: flex;
  gap: 1rem;
  box-sizing: border-box;
}

.api-docs-nav {
  flex: 0 0 220px;
  background: white;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  height: fit-content;
  position: sticky;
  top: 1rem;
}

.nav-button {
  display: block;
  width: 100%;
  padding: 12px 15px;
  margin-bottom: 10px;
  border: none;
  background: #f5f5f5;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
  text-align: left;
  transition: all 0.3s ease;
  color: #333;
}

.nav-button:hover {
  background: #e0e0e0;
  transform: translateX(5px);
}

.nav-button.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.api-docs-content {
  flex: 1 1;
  background: white;
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 0;
  box-sizing: border-box;
}

.endpoint-section {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.endpoint-section h2 {
  color: #333;
  margin-bottom: 10px;
  font-size: 2rem;
}

.endpoint-description {
  color: #666;
  margin-bottom: 30px;
  font-size: 1.1rem;
}

.method-card {
  background: #f9f9f9;
  border-left: 4px solid #667eea;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 25px;
}

.method-card.error {
  border-left-color: #c00;
  color: #c00;
}

.option-roi-badges button {
  margin: 2px;
}

.method-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
}

.method-badge {
  padding: 6px 12px;
  border-radius: 5px;
  font-weight: bold;
  font-size: 0.85rem;
  text-transform: uppercase;
}

.method-get {
  background: #4caf50;
  color: white;
}

.method-post {
  background: #2196f3;
  color: white;
}

.method-put {
  background: #ff9800;
  color: white;
}

.method-patch {
  background: #ff9800;
  color: white;
}

.method-delete {
  background: #f44336;
  color: white;
}

.method-path {
  font-size: 1.1rem;
  color: #333;
  font-weight: 500;
}

.method-description {
  color: #555;
  margin-bottom: 20px;
  font-size: 1rem;
}

.params-section {
  margin: 20px 0;
}

.params-section h4 {
  color: #333;
  margin-bottom: 10px;
  font-size: 1.1rem;
}

.params-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 6px;
  overflow: hidden;
}

.params-table thead {
  background: #667eea;
  color: white;
}

.params-table th,
.params-table td {
  padding: 12px;
  text-align: left;
}

.params-table tbody tr {
  border-bottom: 1px solid #eee;
}

.params-table tbody tr:hover {
  background: #f5f5f5;
}

.params-table code {
  background: #f0f0f0;
  padding: 3px 6px;
  border-radius: 3px;
  font-size: 0.9rem;
}

.examples-section {
  margin-top: 25px;
}

.examples-section h4 {
  color: #333;
  margin-bottom: 15px;
  font-size: 1.1rem;
}

.example-box {
  background: #2d2d2d;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 15px;
  position: relative;
}

.example-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  color: #888;
  font-size: 0.9rem;
}

.copy-btn {
  background: #667eea;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: background 0.3s ease;
}

.copy-btn:hover {
  background: #5568d3;
}

.example-code {
  color: #a9dc76;
  font-size: 0.95rem;
  word-break: break-all;
  display: block;
  line-height: 1.6;
}

.api-docs-footer {
  width: 100%;
  margin: 1rem 0 0;
  padding: 1.5rem 0.5rem;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.api-docs-footer h3 {
  color: #333;
  margin-bottom: 20px;
  font-size: 1.8rem;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.info-card {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  border-left: 4px solid #667eea;
}

.info-card h4 {
  color: #333;
  margin-bottom: 10px;
  font-size: 1.2rem;
}

.info-card p {
  color: #666;
  margin-bottom: 10px;
  line-height: 1.6;
}

.info-card ul {
  margin: 10px 0;
  padding-left: 20px;
  color: #666;
}

.info-card li {
  margin-bottom: 5px;
}

.info-card code {
  background: #e0e0e0;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.9rem;
}

.info-card pre {
  background: #2d2d2d;
  color: #a9dc76;
  padding: 15px;
  border-radius: 6px;
  overflow-x: auto;
  font-size: 0.9rem;
  margin-top: 10px;
}

@media (max-width: 1200px) {
  .api-docs-container {
    padding: 0 0.25rem;
    gap: 0.75rem;
  }
  
  .api-docs-nav {
    flex: 0 0 200px;
    padding: 12px;
  }
  
  .api-docs-content {
    padding: 1rem;
  }
  
  .api-docs-footer {
    padding: 1rem 0.25rem;
  }
}

@media (max-width: 768px) {
  .api-docs-header {
    padding: 0.75rem;
  }
  
  .api-docs-header h1 {
    font-size: 2rem;
  }
  
  .api-docs-header p {
    font-size: 1rem;
  }
  
  .api-docs-container {
    flex-direction: column;
    padding: 0 0.25rem;
    gap: 0.5rem;
  }

  .api-docs-nav {
    position: static;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    flex: 1 1 auto;
  }

  .nav-button {
    flex: 1 1;
    min-width: 120px;
    padding: 10px 12px;
    font-size: 0.9rem;
  }

  .api-docs-content {
    padding: 1rem;
  }
  
  .endpoint-section h2 {
    font-size: 1.5rem;
  }
  
  .method-card {
    padding: 15px;
  }
  
  .params-table th,
  .params-table td {
    padding: 8px;
    font-size: 0.85rem;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .api-docs-footer {
    padding: 1rem 0.25rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/ApiDocs.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;EACZ,sCAAsC;EACtC,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".api-docs {\n  min-height: 100vh;\n  background: #f5f5f5;\n  padding: 0;\n}\n\n.api-docs-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 1.25rem 2rem;\n  color: white;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.api-base-url {\n  margin-top: 15px;\n  font-size: 0.95rem;\n}\n\n.api-base-url code {\n  background: rgba(255, 255, 255, 0.2);\n  padding: 5px 10px;\n  border-radius: 5px;\n  font-size: 1rem;\n}\n\n.api-docs-container {\n  width: 100%;\n  margin: 2rem auto;\n  padding: 0 2rem;\n  max-width: 1400px;\n  display: flex;\n  gap: 1rem;\n  box-sizing: border-box;\n}\n\n.api-docs-nav {\n  flex: 0 0 220px;\n  background: white;\n  border-radius: 10px;\n  padding: 15px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  height: fit-content;\n  position: sticky;\n  top: 1rem;\n}\n\n.nav-button {\n  display: block;\n  width: 100%;\n  padding: 12px 15px;\n  margin-bottom: 10px;\n  border: none;\n  background: #f5f5f5;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 500;\n  text-align: left;\n  transition: all 0.3s ease;\n  color: #333;\n}\n\n.nav-button:hover {\n  background: #e0e0e0;\n  transform: translateX(5px);\n}\n\n.nav-button.active {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.api-docs-content {\n  flex: 1;\n  background: white;\n  border-radius: 10px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.endpoint-section {\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.endpoint-section h2 {\n  color: #333;\n  margin-bottom: 10px;\n  font-size: 2rem;\n}\n\n.endpoint-description {\n  color: #666;\n  margin-bottom: 30px;\n  font-size: 1.1rem;\n}\n\n.method-card {\n  background: #f9f9f9;\n  border-left: 4px solid #667eea;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 25px;\n}\n\n.method-card.error {\n  border-left-color: #c00;\n  color: #c00;\n}\n\n.option-roi-badges button {\n  margin: 2px;\n}\n\n.method-header {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 15px;\n}\n\n.method-badge {\n  padding: 6px 12px;\n  border-radius: 5px;\n  font-weight: bold;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n}\n\n.method-get {\n  background: #4caf50;\n  color: white;\n}\n\n.method-post {\n  background: #2196f3;\n  color: white;\n}\n\n.method-put {\n  background: #ff9800;\n  color: white;\n}\n\n.method-patch {\n  background: #ff9800;\n  color: white;\n}\n\n.method-delete {\n  background: #f44336;\n  color: white;\n}\n\n.method-path {\n  font-size: 1.1rem;\n  color: #333;\n  font-weight: 500;\n}\n\n.method-description {\n  color: #555;\n  margin-bottom: 20px;\n  font-size: 1rem;\n}\n\n.params-section {\n  margin: 20px 0;\n}\n\n.params-section h4 {\n  color: #333;\n  margin-bottom: 10px;\n  font-size: 1.1rem;\n}\n\n.params-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.params-table thead {\n  background: #667eea;\n  color: white;\n}\n\n.params-table th,\n.params-table td {\n  padding: 12px;\n  text-align: left;\n}\n\n.params-table tbody tr {\n  border-bottom: 1px solid #eee;\n}\n\n.params-table tbody tr:hover {\n  background: #f5f5f5;\n}\n\n.params-table code {\n  background: #f0f0f0;\n  padding: 3px 6px;\n  border-radius: 3px;\n  font-size: 0.9rem;\n}\n\n.examples-section {\n  margin-top: 25px;\n}\n\n.examples-section h4 {\n  color: #333;\n  margin-bottom: 15px;\n  font-size: 1.1rem;\n}\n\n.example-box {\n  background: #2d2d2d;\n  border-radius: 6px;\n  padding: 15px;\n  margin-bottom: 15px;\n  position: relative;\n}\n\n.example-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  color: #888;\n  font-size: 0.9rem;\n}\n\n.copy-btn {\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: background 0.3s ease;\n}\n\n.copy-btn:hover {\n  background: #5568d3;\n}\n\n.example-code {\n  color: #a9dc76;\n  font-size: 0.95rem;\n  word-break: break-all;\n  display: block;\n  line-height: 1.6;\n}\n\n.api-docs-footer {\n  width: 100%;\n  margin: 1rem 0 0;\n  padding: 1.5rem 0.5rem;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n}\n\n.api-docs-footer h3 {\n  color: #333;\n  margin-bottom: 20px;\n  font-size: 1.8rem;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.info-card {\n  background: #f9f9f9;\n  border-radius: 8px;\n  padding: 20px;\n  border-left: 4px solid #667eea;\n}\n\n.info-card h4 {\n  color: #333;\n  margin-bottom: 10px;\n  font-size: 1.2rem;\n}\n\n.info-card p {\n  color: #666;\n  margin-bottom: 10px;\n  line-height: 1.6;\n}\n\n.info-card ul {\n  margin: 10px 0;\n  padding-left: 20px;\n  color: #666;\n}\n\n.info-card li {\n  margin-bottom: 5px;\n}\n\n.info-card code {\n  background: #e0e0e0;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 0.9rem;\n}\n\n.info-card pre {\n  background: #2d2d2d;\n  color: #a9dc76;\n  padding: 15px;\n  border-radius: 6px;\n  overflow-x: auto;\n  font-size: 0.9rem;\n  margin-top: 10px;\n}\n\n@media (max-width: 1200px) {\n  .api-docs-container {\n    padding: 0 0.25rem;\n    gap: 0.75rem;\n  }\n  \n  .api-docs-nav {\n    flex: 0 0 200px;\n    padding: 12px;\n  }\n  \n  .api-docs-content {\n    padding: 1rem;\n  }\n  \n  .api-docs-footer {\n    padding: 1rem 0.25rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .api-docs-header {\n    padding: 0.75rem;\n  }\n  \n  .api-docs-header h1 {\n    font-size: 2rem;\n  }\n  \n  .api-docs-header p {\n    font-size: 1rem;\n  }\n  \n  .api-docs-container {\n    flex-direction: column;\n    padding: 0 0.25rem;\n    gap: 0.5rem;\n  }\n\n  .api-docs-nav {\n    position: static;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    flex: 1 1 auto;\n  }\n\n  .nav-button {\n    flex: 1;\n    min-width: 120px;\n    padding: 10px 12px;\n    font-size: 0.9rem;\n  }\n\n  .api-docs-content {\n    padding: 1rem;\n  }\n  \n  .endpoint-section h2 {\n    font-size: 1.5rem;\n  }\n  \n  .method-card {\n    padding: 15px;\n  }\n  \n  .params-table th,\n  .params-table td {\n    padding: 8px;\n    font-size: 0.85rem;\n  }\n\n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .api-docs-footer {\n    padding: 1rem 0.25rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
